import lang from '../../lib/language';
import { FeatureFlags } from '../../lib/util/flags/types';

import dashboardIcon from '../../assets/img/icon-dashboard.svg';
import dashboardIconActive from '../../assets/img/icon-dashboard-active.svg';
import discoverIcon from '../../assets/img/icon-discover.svg';
import discoverIconActive from '../../assets/img/icon-discover-active.svg';
import payoutIcon from '../../assets/img/icon-payout.svg';
import payoutIconActive from '../../assets/img/icon-payout-active.svg';
import profileIcon from '../../assets/img/icon-profile-downbar.svg';
import profileIconActive from '../../assets/img/icon-profile-downbar-active.svg';
import referralsIcon from '../../assets/img/icon-referrals.svg';
import referralsIconActive from '../../assets/img/icon-referrals-active.svg';
import watchlistIcon from '../../assets/img/icon-watchlist.svg';
import watchlistIconActive from '../../assets/img/icon-watchlist-active.svg';
import { UI_ROUTES } from '../../util/routes';

import { DownBarIdType, DownBarItem } from './Downbar.types';

export const MENU_LIST: DownBarItem[] = [
  {
    id: DownBarIdType.Dashboard,
    label: lang.commonDashboard(),
    path: UI_ROUTES.dashboard,
    img: <img src={dashboardIcon} alt="icon dashboard" />,
    activeImg: <img src={dashboardIconActive} alt="icon dashboard" />,
  },
  {
    id: DownBarIdType.Watchlist,
    label: lang.commonWatchlist(),
    path: UI_ROUTES.overview,
    img: <img src={watchlistIcon} alt="icon watchlist" />,
    activeImg: <img src={watchlistIconActive} alt="icon watchlist" />,
  },
  {
    id: DownBarIdType.Discover,
    label: lang.commonDiscoverTitle(),
    path: UI_ROUTES.discover,
    img: <img src={discoverIcon} alt="icon discover" />,
    activeImg: <img src={discoverIconActive} alt="icon discover" />,
  },
  {
    id: DownBarIdType.Payouts,
    label: lang.commonPayoutsTitle(),
    path: UI_ROUTES.payouts,
    img: <img src={payoutIcon} alt="payouts" />,
    activeImg: <img src={payoutIconActive} alt="payouts" />,
    hiddenByFeatureFlag: FeatureFlags.referrals,
  },
  {
    id: DownBarIdType.Referrals,
    label: lang.referralsTitle(),
    path: UI_ROUTES.referrals,
    img: <img src={referralsIcon} alt="icon referrals" />,
    activeImg: <img src={referralsIconActive} alt="icon referrals" />,
    featureFlag: FeatureFlags.referrals,
  },
  {
    id: DownBarIdType.MyProfile,
    label: lang.mobileProfileHeaderTitle(),
    path: UI_ROUTES.myProfile,
    img: <img src={profileIcon} alt="icon my profile" />,
    activeImg: <img src={profileIconActive} alt="icon my profile" />,
  },
];

/** Every flag the bar depends on, so `useFlags` stays in step with MENU_LIST. */
export const DOWNBAR_FEATURE_FLAGS: FeatureFlags[] = [
  ...new Set(
    MENU_LIST
      .flatMap(item => [ item.featureFlag, item.hiddenByFeatureFlag ])
      .filter((flag): flag is FeatureFlags => !!flag),
  ),
];
